<div class="clearable-input" [ngClass]="{'disabled': disabled}">
    <input type="text" [(ngModel)]="_value" (input)="onInput($event)" (blur)='onBlur()' [disabled]="disabled"
           [attr.maxlength]="maxLength > 0 ? maxLength : null"
           class="clearable-input-field" [placeholder]="defaultValue" #clearableInput>
    <button *ngIf="!disabled" (click)="onClear()" class="btn btn-icon" title="Delete">
        <i class="fal fa-times"></i>
    </button>
</div>
